export default "__VITE_ASSET__C1CPkE4t__"